import { isNil } from 'lodash';
import { CSSProperties } from 'react';
import { IconAvatar } from '@shared/components/Icon';
import { View } from '@shared/components/View';
import { Colors } from '@shared/styles';
import { API } from '@shared/types/api';
import { Image } from './Image';
import classNames from './business.module.css';

interface BusinessImageProps {
  business?: API.BusinessFragment;
  /** Diameter in px. Without it the image is 48px with a faint border. */
  size?: number;
}

const colors = Colors.v2.avatar.business;
const DEFAULT_SIZE = 48;

export function BusinessImage({ business, size }: BusinessImageProps) {
  const isSized = !isNil(size);

  if (!business) {
    return (
      <View
        className={[classNames.placeholder, isSized && classNames.sized]}
        vars={{ 'business-image-size': size }}
      />
    );
  }

  if (!!business.img) {
    return (
      <Image
        source={{ uri: business.img }}
        className={[classNames.image, isSized && classNames.sized]}
        style={isSized ? ({ '--business-image-size': size } as CSSProperties) : undefined}
      />
    );
  }

  return (
    <IconAvatar
      name="storefront"
      size={size ?? DEFAULT_SIZE}
      color="white"
      backgroundColor={colors[business.id % colors.length]}
    />
  );
}
